import { useTranslation } from 'react-i18next';

import { PageContainer } from '@/shared/ui';

import { ImportPanel } from '../components/ImportPanel';

/**
 * Standalone bulk-catalog-import page (`/catalog/import`).
 *
 * Shares its body with the {@link ImportPanel} that also powers the import
 * slideout on the Products workspace — same form, two entry points.
 */
export function ImportPage() {
  const { t } = useTranslation('catalog');
  return (
    <PageContainer title={t('import.title')} subtitle={t('import.pageSubtitle')} maxWidth={900}>
      <ImportPanel />
    </PageContainer>
  );
}
